import { useState } from 'react';
import {
  NachversandStore,
  NachversandStoreProvider,
} from '../../../../store/NachversandStore';
import { VersandScreen } from './VersandScreen';

export const VersandScreenWrapper = () => {
  // created once per mount, not per render
  const [store] = useState(() => new NachversandStore());

  return (
    <NachversandStoreProvider store={store}>
      <VersandScreen />
    </NachversandStoreProvider>
  );
};
